import { put } from "../../../../http";
import { FavouriteItem, FavouriteItemType } from "../../../types";
import { favouritesBaseApiUrl } from "../../favouritesBaseUrl";
import { favouriteBulkUrl } from "../../queries/favouriteItems/favouriteItems.constants";

import { FavouriteMapDTO, FavouriteSlideDTO, FavouriteObjectType, FavouriteBulkDTO } from "../../types";
import { UpdateFavouriteMutationRequest } from "./updateFavourite.types";

export const updateFavourite = async (payload: UpdateFavouriteMutationRequest) => {
  const { newFavouriteItem, oldFavouriteItem } = payload;

  if (newFavouriteItem.type === FavouriteItemType.Map) {
    const newFavouriteMapItem: FavouriteMapDTO = {
      id: oldFavouriteItem.id,
      objectType: FavouriteObjectType.Map,
      name: newFavouriteItem.name,
      mark: {
        id: oldFavouriteItem.id,
        marks: newFavouriteItem.mark.parameters,
      },
      lastModified: oldFavouriteItem.date,
    };
    await put(`${favouritesBaseApiUrl}/favourites/${oldFavouriteItem.id}`, newFavouriteMapItem);
  } else if (newFavouriteItem.type === FavouriteItemType.Slide) {
    const newFavouriteSlideItem: FavouriteSlideDTO = {
      id: oldFavouriteItem.id,
      objectType: FavouriteObjectType.Slide,
      name: newFavouriteItem.name,
      mark: {
        id: oldFavouriteItem.id,
        reportId: newFavouriteItem.mark.reportId,
        marks: newFavouriteItem.mark.parameters,
      },
      lastModified: oldFavouriteItem.date,
    };
    await put(`${favouritesBaseApiUrl}/favourites/${oldFavouriteItem.id}`, newFavouriteSlideItem);
  } else if (newFavouriteItem.type === FavouriteItemType.BulkExport) {
    const newFavouriteBulkItem: FavouriteBulkDTO = {
      id: oldFavouriteItem.id,
      bulkExportSettings: newFavouriteItem.mark?.parameters,
      lastModified: oldFavouriteItem.date,
      isSavedSetting: false,
    };
    await put(`${favouriteBulkUrl}/${oldFavouriteItem.id}`, newFavouriteBulkItem);
  } 
};
